(() => {
  const ownerLocks = new Map();
  const state = {
    isFixed: false,
    scrollY: 0,
    inlineStyles: {
      position: '',
      top: '',
      left: '',
      right: '',
      width: '',
    },
  };

  function toOwnerKey(ownerKey) {
    return ownerKey == null ? 'default' : String(ownerKey);
  }

  function toClassSet(className) {
    if (!className) return new Set();
    if (Array.isArray(className)) return new Set(className.filter(Boolean));
    return new Set([className]);
  }

  function activeClassNames() {
    const classNames = new Set();
    ownerLocks.forEach((classes) => {
      classes.forEach((className) => classNames.add(className));
    });
    return classNames;
  }

  function applyFixedBodyLock() {
    if (state.isFixed) return;

    state.scrollY = window.scrollY || document.documentElement.scrollTop || 0;
    state.inlineStyles.position = document.body.style.position;
    state.inlineStyles.top = document.body.style.top;
    state.inlineStyles.left = document.body.style.left;
    state.inlineStyles.right = document.body.style.right;
    state.inlineStyles.width = document.body.style.width;

    document.body.style.position = 'fixed';
    document.body.style.top = `-${state.scrollY}px`;
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.width = '100%';
    state.isFixed = true;
  }

  function clearFixedBodyLock() {
    if (!state.isFixed) return;

    document.body.style.position = state.inlineStyles.position;
    document.body.style.top = state.inlineStyles.top;
    document.body.style.left = state.inlineStyles.left;
    document.body.style.right = state.inlineStyles.right;
    document.body.style.width = state.inlineStyles.width;

    const scrollY = state.scrollY;
    state.scrollY = 0;
    state.isFixed = false;

    // Same task as the unfix: restoring a frame later painted the page at the top
    // for a frame and then scrolled back (seen when closing the cart drawer).
    window.scrollTo({ top: scrollY, left: 0, behavior: 'instant' });
  }

  function sync() {
    const classes = activeClassNames();
    const shouldLock = ownerLocks.size > 0;

    if (shouldLock) {
      applyFixedBodyLock();
      classes.forEach((className) => document.body.classList.add(className));
      return;
    }

    clearFixedBodyLock();
  }

  function lock(ownerKey, className = 'overflow-hidden') {
    const key = toOwnerKey(ownerKey);
    const classes = toClassSet(className);
    const existing = ownerLocks.get(key);

    if (existing) {
      classes.forEach((newClass) => existing.add(newClass));
    } else {
      ownerLocks.set(key, classes);
    }

    sync();
  }

  function unlock(ownerKey) {
    const key = toOwnerKey(ownerKey);
    const classes = ownerLocks.get(key);
    if (!classes) return;

    classes.forEach((className) => {
      let shouldKeep = false;
      ownerLocks.forEach((ownerClasses, owner) => {
        if (owner !== key && ownerClasses.has(className)) shouldKeep = true;
      });
      if (!shouldKeep) document.body.classList.remove(className);
    });

    ownerLocks.delete(key);
    sync();
  }

  window.DrBodyScrollLock = {
    lock,
    unlock,
    isLocked() {
      return ownerLocks.size > 0;
    },
  };
})();
